import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const IntroduzionePage = lazy(() => import('../pages/introduzione/page'));
const ContestoStoricoPage = lazy(() => import('../pages/contesto-storico/page'));
const PersonaggiPage = lazy(() => import('../pages/personaggi/page'));
const TimelinePage = lazy(() => import('../pages/timeline/page'));
const RisorsePage = lazy(() => import('../pages/risorse/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/introduzione',
    element: <IntroduzionePage />,
  },
  {
    path: '/contesto-storico',
    element: <ContestoStoricoPage />,
  },
  {
    path: '/personaggi',
    element: <PersonaggiPage />,
  },
  {
    path: '/timeline',
    element: <TimelinePage />,
  },
  {
    path: '/risorse',
    element: <RisorsePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
